import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from '../../../../play-core/hooks/use-search-params';
import { loadSectionDetail } from '../../api/pac/load-section-detail';
import { useLoadingBar } from '../../components/LoadingBar/LoadingBarProvider';
import { queryKeys } from '../../config/use-query';
import { useVideoConfig } from '../../config/VideoAppContext';
import { useAxios } from '../../hooks/use-axios';
export const useSectionDetail = ({
  preloadedSections: initialSectionDetail
}) => {
  const {
    usePreview,
    previewDate
  } = useVideoConfig();
  const axios = useAxios();
  const {
    id: sectionId = ''
  } = useSearchParams();
  const {
    data: sectionDetail,
    isLoading: isSectionDetailLoading
  } = useQuery({
    queryKey: [queryKeys.SectionDetail(sectionId ?? ''), {
      usePreview,
      previewDate
    }, axios],
    queryFn: () => loadSectionDetail(axios, sectionId, usePreview, previewDate),
    initialData: initialSectionDetail?.[sectionId],
    enabled: !!sectionId
  });
  const isLoading = isSectionDetailLoading;
  const hasData = section => {
    if (section?.sectionType === 'MediaSection') {
      return section.data.data.length > 0;
    }
    if (section?.sectionType === 'ShowSection') {
      return section.data.length > 0;
    }
    if (section?.sectionType === 'MediaSectionWithShow') {
      return section.data.medias.length > 0 || section.data.show;
    }
    return false;
  };
  useLoadingBar(isLoading);
  return {
    sectionDetailData: sectionDetail,
    isLoading,
    notFound: !isLoading && !hasData(sectionDetail)
  };
};